import ViewControlHeader from './view_control_header';

export default ViewControlHeader;
